

module shoppinglist {
  'use strict';

  export class ShareModalCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      'shoppingListService', 
      '$timeout',
      '$mdDialog',
      'debounce',
      'pageMetaService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IShareModalCtrlScope,
      private shoppingListService: IShoppingListService,
      private $timeout: ng.ITimeoutService,
      private $mdDialog: ng.material.IDialogService,
      private debounce : navigation.IDebounceService,
      private pageMetaService: navigation.IPageMetaService
      ) {

        $scope.vm = this;
      
        $scope.meta = pageMetaService.getPageMeta;

        $scope.sharemode = 'offer';
        $scope.wizardpage = 1;
        $scope.requestOnGoing = false;

        this.setRequestOnGoing = debounce(this.setRequestOnGoing, 500, false);
      }

    //typedef for this.locals.x 
    locals : { parentScope: IShoppingListDirectiveDirectiveScope };

    
    public $onInit(): void {
      this.$scope.parentScope = this.locals.parentScope;
      this.$scope.shoppingListId = this.locals.parentScope.shoppingList.ID
    }
    
    setRequestOnGoing(value) {
      this.$scope.requestOnGoing = value;
    }

    sendMail() {
      if (this.$scope.sharemode == 'offer') {
        this.$scope.cartShareForm.email.$setViewValue(null);
        this.$scope.cartShareForm.$commitViewValue();
      }

      this.$scope.cartShareForm.$setSubmitted();
      if (!this.$scope.cartShareForm.$valid) {
        return;
      }
              
      this.$scope.Error = null;

      if (this.$scope.sharemode == 'offer') {
        this.$scope.email = this.$scope.QuoteRequestEmail;
      }


                
      this.shoppingListService.shareList(this.$scope.parentScope.shoppingList.ID, this.$scope.sharemode != 'link', this.$scope.email, this.$scope.message, (data) => {
        this.setRequestOnGoing(false);

        if (!data.ListId) {
          this.$scope.Error = data.Error;
          if (data.Error == 'EMAIL') {
            this.$scope.cartShareForm.email.$setValidity("pattern", false);
            return;
          }
        } else {
          this.$scope.shoppingListId = data.ListId;
          this.$scope.shoppingListLink = data.Url;
        }
        
        this.$scope.wizardpage += 1;
      });   


      this.setRequestOnGoing(true);
    }

    generateLink() {
     this.$scope.Error = null;
      this.shoppingListService.shareList(this.$scope.parentScope.shoppingList.ID, this.$scope.sharemode != 'link', this.$scope.email, this.$scope.message, (data) => {

        if (!data.ListId) {
          this.$scope.Error = data.Error;
        } else {
          this.$scope.shoppingListId = data.ListId;
          this.$scope.shoppingListLink = data.Url;
        }
        
        this.setRequestOnGoing(false);
        this.$scope.wizardpage += 1;
        //this.$scope.$apply();
      });
      this.setRequestOnGoing(true);

    }

    closeDialog() {
      this.$mdDialog.hide();
    }

    cancelDialog() {
      this.$mdDialog.cancel();
    };

    nextPage() {
      this.$scope.wizardpage = this.$scope.wizardpage + 1;
        
      this.$timeout(() => {
        this.$scope.$broadcast('md-resize-textarea');
      });
    }
  }
};
    